import { render } from "./UiDbSubscriptionsProps.vue?vue&type=template&id=31be8e48"
import script from "./UiDbSubscriptionsProps.vue?vue&type=script&lang=js"
export * from "./UiDbSubscriptionsProps.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__